<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="2"></HeaderNav>
    <!-- <Banner :banner="bannerList"  @click="loseFocus()"></Banner> -->
    <div class="intro_box cont840 pa30">
        <div class="title_2">新资讯</div>
        <hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-21121014213tx.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.12.16</i></p>
                <p class="mt20 font_s17">Super us，Beyond us</p>
                <p class="mt10">品牌年度盛典</p>
                <p class="mt30 font_s16"></p>
                <a @click="toDetail(1)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-2111121fr4308.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.12.13</i></p>
                <p class="mt20 font_s17">进博会LEWA魅力出圈</p>
                <p class="mt10">进博会首秀回顾</p>
                <p class="mt30 font_s16"></p>
                <a @click="toDetail(2)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-2111121f42d95.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.11.12</i></p>
                <p class="mt20 font_s17">美肤新势力“耀”你好看</p>
                <p class="mt10">我们上海见！</p>
                <p class="mt30 font_s16"></p>
                <a @click="toDetail(3)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-2111121f04u24.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.11.12</i></p>
                <p class="mt20 font_s17">LEWA株式会社将亮相进博会</p>
                <p class="mt10">进博会，我们来啦</p>
                <p class="mt30 font_s16"></p>
                <a  @click="toDetail(4)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-21051gg013420.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.05.17</i></p>
                <p class="mt20 font_s17">Luara实力出圈，引领美肌风尚</p>
                <p class="mt10"></p>
                <p class="mt30 font_s16">上海CBE 邂逅夏日奇“肌”</p>
                <a  @click="toDetail(5)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-21043016451a31.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.05.07</i></p>
                <p class="mt20 font_s17">当Luara撞上时尚之都</p>
                <p class="mt10">Luara成都专柜开业</p>
                <p class="mt30 font_s16"></p>
                <a @click="toDetail(6)" >了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-210406152303321.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.04.06</i></p>
                <p class="mt20 font_s17">定义美 绽放美</p>
                <p class="mt10">以美为媒 携手同行</p>
                <p class="mt30 font_s16"></p>
                <a  @click="toDetail(7)" >了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-210220100605k8.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.02.20</i></p>
                <p class="mt20 font_s17">新品来袭 Luara眼霜</p>
                <p class="mt10">开启明眸焕采之旅</p>
                <p class="mt30 font_s16"></p>
                <a @click="toDetail(8)" >了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-20122515034cf.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.02.20</i></p>
                <p class="mt20 font_s17">Luara武汉专柜</p>
                <p class="mt10"></p>
                <p class="mt30 font_s16">坚持将美的理念带给大众，引领每一位爱美人士寻找属于自己的美肌方式。</p>
                <a @click="toDetail(9)" >了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-201103113504s9.png"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2020.11.03</i></p>
                <p class="mt20 font_s17">与美同行 绽放光芒</p>
                <p class="mt10">以美的名义，邀你同行！</p>
                <p class="mt30 font_s16"></p>
                <a @click="toDetail(10)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-2009301r534c3.png"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2020.10.16</i></p>
                <p class="mt20 font_s17">点击解锁三亚游学指南</p>
                <p class="mt10">探寻真实的自我</p>
                <p class="mt30 font_s16">日运全球三亚游学之行，即将起航。探索世界密码，探寻真实的自我~</p>
                <a @click="toDetail(11)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/1-20091qk63v12.gif"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2020.10.16</i></p>
                <p class="mt20 font_s17">约定广州CIBE，Luara光芒将再度闪耀！</p>
                <p class="mt10">再次释放美丽</p>
                <p class="mt30 font_s16">九月，Luara将受邀入驻广州美博会，向大众展示高品质的产品与正宗的日式护肤手法。</p>
                <a @click="toDetail(12)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/news_1.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2020.09.18</i></p>
                <p class="mt20 font_s17">Luara即将进驻上海美博会</p>
                <p class="mt10">现场解码美</p>
                <p class="mt30 font_s16">上海CBE。亚洲区域首屈一指的美容行业贸易盛会。2020年，Luara受邀入驻上海国际美博会,分享美丽理念，展示美丽新风向。</p>
                <a @click="toDetail(13)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/news_2.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2021.02.20</i></p>
                <p class="mt20 font_s17">Luara上海专柜</p>
                <p class="mt10">邀你解锁发光肌，感受肌肤的</p>
                <p class="mt30 font_s16">在仲夏，在这一个织梦的季节，Luara国内首家专柜强势来袭，即将入驻上海伊势丹，为爱美女性打造水润明亮、具有通透感的肌肤，带给大家如光般永恒的透亮肌肤。</p>
                <a @click="toDetail(14)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/news_3.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2020.09.18</i></p>
                <p class="mt20 font_s17">Luara快闪店第3站惊艳来袭</p>
                <p class="mt10">Luara与您的美丽之约，如期而至</p>
                <p class="mt30 font_s16">邂逅Luara，邂逅美丽！2019年4月1日，日本新宿伊势丹B2层化妆品区，Laura，与您不见不散对话专业肌肤护理顾问，掌握美肌奥秘，试用Luara全线产品，畅快买买买，尽在Luara快闪店。</p>
                <a @click="toDetail(15)" >了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/news_4.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2020.09.15</i></p>
                <p class="mt20 font_s17">Luara肌底液焕新来袭</p>
                <p class="mt10">Luara肌底液迭代升级，全新包装</p>
                <p class="mt30 font_s16">肌底液，作为Luara全系列中的明星产品，凭借着院线产品专业的肌肤护理功效和优良的品质，备受日本美容教母佐伯千津老师、日本"不老仙妻"水谷雅子等名人的推崇，在中国也拥有许多“铁粉"。</p>
                <a @click="toDetail(16)">了解详情</a>
            </dd>
        </dl><hr class="hr_1 mb30">
        <dl>
            <dt><img src="static/picture/news_5.jpg"></dt>
            <dd>
                <p><span class="font_s14">NEWS</span><i>2020.09.15</i></p>
                <p class="mt20 font_s17">听说长得好看的人，洗脸都用棉柔巾！</p>
                <p class="mt10">生活故事棉柔巾，全新上市！</p>
                <p class="mt30 font_s16">生活故事绵柔巾，贴心盒装、袋装任选，盒装，摆在家中美观大方；袋装，出门携带方便；抽取式设计，用一张抽一张，不会滋生螨虫和细菌，不会对皮肤造成二次污染。</p>
                <a @click="toDetail(17)" >了解详情</a>
            </dd>
        </dl>
    </div>
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id:'',
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
      bannerList: [
        {url:'static/picture/luara_banner1.jpg'},
        {url:'static/picture/luara_banner2.jpg'},
        {url:'static/picture/luara_banner3.jpg'},
      ],
    };
  },
  created() {

  },
  methods: {
     //跳转到詳情
    toDetail(id) {
      this.$router.push({ path: '/NewsDetail', query: { id: id } });
    },

    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
<style scoped>
@media (min-width: 768px){
	.nav li {
		padding: 0 15px;
	}
	.pc_img{
		display: none;
	}
	.wap_img{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: block;
	}
}


@media (min-width: 1110px) {
    .cont840 {
        width: 840px;
        margin: 0 auto;
    }
	.pc_img{
		display: block;
	}
	.wap_img{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: none;
	}
}
/*------------about_intro.html  start----------------*/
.intro_box{
	overflow: hidden;
	padding: 40px 0 60px;
}
.intro_box img{
	display: block;
	margin: 0 auto;
	max-width: 100%;
}
.intro_box h1{
	color: #2e2e2e;
	font-size: 18px;
	font-family: Font_Medium;
}
.intro_box p{
	color: #2e2e2e;
	line-height: 26px;
	margin: 0;
	font-size: 15px;
	font-family: Font_Light;
}
.intro_box dl{
	width: 100%;
	overflow: hidden;
}
.intro_box dl dt{
	float: left;
	width: 245px;
}
.intro_box dl.dl_basic dt{
	width: 560px;
}
.intro_box dl.dl_100 dt{
	float: inherit;
	width: 100%;
}
.intro_box dl dt img{
	max-width: 100%;
}

.intro_box dl dd{
	float: right;
	width: calc(100% - 270px);
	color: #2e2e2e;
}
.intro_box dl.dl_basic dd{
	width: calc(100% - 580px);
}
.intro_box dl.dl_100 dd{
	float: inherit;
	width: 100%;
}
.intro_box dl dd h2{
	margin-top: 0;
	font-size: 15px;
	font-family: Font_Medium;
}
.intro_box dl dd p{
	font-size: 15px;
	font-family: Font_Light;
}
.intro_box dl dd h3{
	margin-top: 0;
	font-size: 18px;
	font-family: Font_Medium;
	overflow: hidden;
}
.intro_box dl dd span{
	display: inline-block;
	width: 400px;
	text-align: center;
	height: 54px;
	line-height: 50px;
	margin-right: 130px;
	color: #2e2e2e;
}
.intro_box dl dd i{
	letter-spacing: 1px;
	font-style: normal;
	font-size: 13px;
	font-family: Font_Medium;
}
.intro_box dl dd em{
	width: 32px;
	height: 30px;
	display: block;
    float: left;
	/* background: url(../images/addr.png) no-repeat 0px 0px; */
}
.intro_box dl dd a{
	float: right;
	color: #2e2e2e;
	font-size: 12px;
    font-family: Font_Medium;
	margin-top: 20px;
	padding-right: 15px;
	/* background: url(../images/more_jt.png) no-repeat right center; */
}
.intro_box dl dd a.a_link{
	float: inherit;
    font-family: Font_Medium;
	margin-top: 0;
	background: none;
}
/*------------about_intro.html  end----------------*/

</style>



// WEBPACK FOOTER //
// src/view/plus/news.vue